import api from "../services/api";

class VinHistory {
  debug = process.env.VUE_APP_DEV_DOMAIN === "true";

  list = [];
  finished = false;
  loading = false;
  searchBy = "VehicleType";
  searchOptions = [
    { text: "按车型", value: "VehicleType", placeholder: "输入车型后检索" },
    { text: "按VIN码", value: "vin", placeholder: "输入VIN码后检索" },
  ];

  constructor() {}

  async initList({ keyword, StartTime, EndTime }) {
    this.loading = true;
    try {
      let queryParams = {
        StartTime,
        EndTime,
      };

      if (keyword) {
        queryParams[this.searchBy] = keyword;
      }

      let result = await api.GetRobotSelectRecord(queryParams);
      this.loading = false;
      this.finished = true;

      if (result.ResultType == 1) {
        this.list = result.Data || [];
      } else {
        console.log(result);
        throw new Error(result.Reason || "系统繁忙，请稍后再试");
      }
    } catch (error) {
      this.loading = false;
      this.finished = true;

      console.error(error);
      throw new Error("系统繁忙，请稍后再试");
    }
  }
}
export default new VinHistory();
